import { getPlaymakerMetadata } from './getMetadata';

export default function isAutoplay(metadata) {
  return getPlaymakerMetadata(metadata).playmakerPlayBehavior === 'autoplay';
}
